var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.40538 6L0.330256 1.92487C-0.110085 1.48453 -0.110085 0.770597 0.330256 0.330256C0.770597 -0.110085 1.48453 -0.110085 1.92487 0.330256L6 4.40538L10.0751 0.330256C10.5155 -0.110085 11.2294 -0.110085 11.6697 0.330256C12.1101 0.770597 12.1101 1.48453 11.6697 1.92487L7.59462 6L11.6697 10.0751C12.1101 10.5155 12.1101 11.2294 11.6697 11.6697C11.2294 12.1101 10.5155 12.1101 10.0751 11.6697L6 7.59462L1.92487 11.6697C1.48453 12.1101 0.770597 12.1101 0.330256 11.6697C-0.110085 11.2294 -0.110085 10.5155 0.330256 10.0751L4.40538 6Z","fill":"white"}));
}

CloseInline.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
